<script lang="ts">
import listPanel from '@nuxtDatakodeUtils/components/i3p/panels/list-panel.vue'
import BasicFiltersOverride from '~/components/I3pComponent/list/BasicFiltersOverride.vue'

import Pagination from '~/components/I3pComponent/list/Pagination.vue'
import CommandsListButtons from '~/components/I3pComponent/ListButtons.vue'
import FiltersTemplate from '~/components/I3pComponent/list/FiltersTemplate.vue'
import type { CommandI3pService } from '~/services/commands.i3p.service'
// import CommandData = PildomModules.Majic.Data.CommandData

export default {
    name: 'CommandListPanel',
    components: { FiltersTemplate, CommandsListButtons, Pagination, BasicFiltersOverride },
    extends: listPanel,
    data() {
        return {
            columns: [
                { dataKey: 'id' },
                { dataKey: 'name' },
                { dataKey: 'year' },
                { dataKey: 'credentials.created_at', transform: [this.isDateTime] },
                { dataKey: 'credentials.created_by' },
                { dataKey: 'status', transform: [this.toTranslate], template: [this.isChips] },
            ],
        }
    },
    computed: {
        // exactly the same as i3pService
        // done to get helpers command added in CommandI3pService
        commandI3pService(): CommandI3pService {
            return this.i3pService
        },
    },
    methods: {
    },
}
</script>

<template>
    <FiltersTemplate
        v-if="list?.meta"
        :meta="list.meta"
        :translation-name="list?.model?.translationKey"
        :filters="filters"
        @set-query="setQuery($event)"
        @reset-query="i3pService.resetQuery()"
    >
        <template #filters>
            <BasicFiltersOverride
                ref="filters"
                :filters="filters"
                :translation-name="list?.model?.translationKey"
                @reset-pagination="i3pService.setPagination(1)"
                @load-data="i3pService.loadData()"
            />
            <!-- need to "setQuery" on @loadData if we want to listen to params in url (example : ?year=2025) -->
        </template>
    </FiltersTemplate>

    <list-table
        ref="table"
        class="px-2 my-2"
        :highlight-row="[i3pService.currentEntityK]"
        :loading="loadingList"
        :value-as-view-link="['id', 'name', 'year', 'credentials.created_at', 'credentials.created_by', 'status']"
        :disable-view="true"
        :permission-name="list?.model?.permissionName || ''"
        :translation-name="list?.model?.translationKey || ''"
        :sortable="list?.meta?.allowed_sorts || []"
        :default-url="baseUrl"
        :data="list?.data || []"
        :columns
        no-action
        :show-global-loader="true"
        @default-redirect-clicked="showEntity($event.k)"
        @update-sort="i3pService.setSort($event)"
        @load-data="i3pService.loadData()"
        @reset-pagination="i3pService.setPagination({ number: 1, size: list?.meta?.per_page })"
    >
        <template #customColumn="{ item }">
            <CommandsListButtons
                :item="item"
                :translation-name="list?.model?.translationKey"
                @view-route="showEntity(item.k)"
                @update-route="editEntity(item.k)"
                @create-route="commandI3pService.renewCommand(item)"
                @delete-item="deleteEntity(item.k)"
            />
        </template>
    </list-table>
    <Pagination
        v-if="list?.meta"
        :list
        @load-data="i3pService.loadData()"
    />
</template>
